// Centralized date/time formatting — ALWAYS in Eastern Time (auto EST/EDT).
// Server stores UTC ISO strings; users want to see ET regardless of browser locale.

const TZ = "America/New_York";

const _toDate = (input) => {
  if (!input) return null;
  if (input instanceof Date) return isNaN(input) ? null : input;
  const d = new Date(input);
  return isNaN(d) ? null : d;
};

/** "Apr 27, 2026, 4:32 PM ET" */
export function formatET(input) {
  const d = _toDate(input);
  if (!d) return "";
  return new Intl.DateTimeFormat("en-US", {
    timeZone: TZ,
    year: "numeric", month: "short", day: "numeric",
    hour: "numeric", minute: "2-digit",
    timeZoneName: "short",
  }).format(d);
}

/** "Apr 27, 2026" */
export function formatDateET(input) {
  const d = _toDate(input);
  if (!d) return "";
  return new Intl.DateTimeFormat("en-US", {
    timeZone: TZ,
    year: "numeric", month: "short", day: "numeric",
  }).format(d);
}

/** "4:32 PM ET" */
export function formatTimeET(input) {
  const d = _toDate(input);
  if (!d) return "";
  return new Intl.DateTimeFormat("en-US", {
    timeZone: TZ,
    hour: "numeric", minute: "2-digit",
    timeZoneName: "short",
  }).format(d);
}

/** "2026-04-27" — today's date in ET (for date-only inputs). */
export function todayET() {
  const fmt = new Intl.DateTimeFormat("en-CA", {
    timeZone: TZ,
    year: "numeric", month: "2-digit", day: "2-digit",
  });
  return fmt.format(new Date()); // en-CA → YYYY-MM-DD
}
